export const setOnboardingModalStatus = active => dispatch => {
  dispatch({
    type: "SET_ONBOARDING_MODAL_STATUS",
    payload: {
      active,
    },
  });
};

export const setOtherModalStatus = active => dispatch => {
  dispatch({
    type: "SET_OTHER_MODAL_STATUS",
    payload: {
      active,
    },
  });
};



// WEBPACK FOOTER //
// ./src/actions/OnboardingModalActions/onBoardingModalActions.js